module.exports = [{
      plugin: require('d:/Workspace/Web/arnmstore/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":960},
    },{
      plugin: require('d:/Workspace/Web/arnmstore/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('d:/Workspace/Web/arnmstore/node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[],"modulePath":"d:\\Workspace\\Web\\arnmstore/src/cms/cms.js"},
    },{
      plugin: require('d:/Workspace/Web/arnmstore/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-73379983-2"],"pluginConfig":{"head":true}},
    },{
      plugin: require('d:/Workspace/Web/arnmstore/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('d:/Workspace/Web/arnmstore/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('d:/Workspace/Web/arnmstore/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
